import { userActivityLogger } from "../../../utils/mixpanel";

/**
 * Tracks a prequalification funnel event with the PRD's cross-surface context
 * attached (PRD "TotalCare Pre-qualification Flow", Mixpanel section):
 *
 *  - `app_source: "web"` / `prequal_channel: "app"` — constants for this
 *    surface; the tablet kiosk registers the same pair as Mixpanel super
 *    properties (`in_hospital`), so funnels can be split per surface/channel.
 *  - `hospital_location` — the PRD's name for the value `userActivityLogger`
 *    already sends as `location` on every event; duplicated under the PRD key
 *    so the cross-platform funnel joins on one property name.
 *
 * `session_id` is the one PRD super property still absent on web: the kiosk
 * mints one per customer sitting, but web has no equivalent boundary defined
 * yet — needs a cross-platform decision before it can be added meaningfully.
 *
 * @param {string} eventName Mixpanel event name (`prequalification_*`).
 * @param {Record<string, unknown>} eventData Event-specific properties merged
 *   over the shared context.
 */
export const logPrequalEvent = (
  eventName: string,
  eventData: Record<string, unknown> = {},
): void => {
  let hospitalLocation: string | undefined;
  try {
    // Same store `userActivityLogger` reads for its `location` property.
    hospitalLocation = JSON.parse(localStorage.getItem("persistantState") ?? "null")?.user?.user
      ?.location?.locationName;
  } catch {
    hospitalLocation = undefined;
  }

  userActivityLogger(eventName, {
    app_source: "web",
    prequal_channel: "app",
    ...(hospitalLocation ? { hospital_location: hospitalLocation } : {}),
    ...eventData,
  });
};
